<template>
  <div class="client-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Lista de indicações</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
              <b-col cols="auto">
                <b-form-input type="text" placeholder="Buscar indicação" v-model="searchBy"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de indicações</p>
                  <p class="title"><small>{{ pagination.total }} indicações cadastradas</small></p>
                </div>
              </div>
              <div class="content">

                <div v-if="pagination.lastPage > 1">
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getAffiliates"></b-pagination>
                  <hr>
                </div>

                <table class="table table-responsive w-100 d-block d-md-table">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Email</th>
                      <th>Celular</th>
                      <th>Telefone</th>
                      <th>Afiliado</th>
                      <th>Data de cadastro</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="client in clients" :key="client.id">
                      <td><router-link :to="'/clientes/'+client.id">{{ client.name }}</router-link></td>
                      <td>{{ client.email }}</td>
                      <td>{{ client.cellphone }}</td>
                      <td>{{ client.telephone }}</td>
                      <td><router-link :to="'/afiliados/'+client.affiliate_id">{{ client.affiliate }}</router-link></td>
                      <td>{{ moment(client.created_at).format('DD/MM/YYYY') }}</td>
                    </tr>
                  </tbody>
                </table>
                <p v-if="searchBy == '' && clients.length == 0" class="text-center sub-title">Você ainda não possui nenhuma indicação cadastrada.</p>
                <p v-if="searchBy != '' && clients.length == 0" class="text-center sub-title">A sua busca por indicações não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getAffiliateClients"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        url: '',
        module: '',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        canSee: true,
        canEdit: true,

        clients: [],
        clientsFiltered: [],

        searchBy: ''
      }
    },
    mounted () {
      this.eventBus.$emit('IS_LOADING', true);

      this.url = 'afiliados';
      this.module = 'affiliates';

      this.canSee = true;
      this.canEdit = true;

      this.getAffiliateClients(this.pagination.currentPage);
    },
    watch: {
      searchBy: function() {
        this.getAffiliateClients(1);
      }
    },
    methods: {
      getAffiliateClients(page) {
        let affiliatesData = {
          name: this.searchBy,
          page: page
        };
        this.api.getAffiliateClients(affiliatesData).then(res => {
          this.clients = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;

          this.eventBus.$emit('IS_LOADING', false);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Affiliate Clients', res);
        }).catch(err => {
          this.$swal('Ops...', 'Não conseguimos carregar as indicações! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Affiliate Clients', err.response);
        });
      },
    }
  }
</script>

<style lang="scss">
  .main-content-cj {
    &.client-list {
      padding: 20px 0;

      .box-cj {
        .content {
          th {
            font-size: 14px;
            color: $cadetGray;
            border-top: 0;
          }

          tbody {
            font-size: 14px;
            color: $waikawaGray;

            .line-add {
              padding: 10px 0;
            }

            tr:nth-child(even) {
              background-color: $whisper;
            }

            tr:nth-child(odd) {
            }
          }
        }
      }
    }
  }
</style>
